export default "__VITE_ASSET__BoW1MFDV__"